import { RootState } from '..';

export const selectPages = (state: RootState) => state.site.pages;
